import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui.css";
import "jquery-ui-dist/jquery-ui";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css"; 
import axios from "axios";



const Sidefilter = ({
  filters,
  setFilters,
  industriesList,
  handleSearch,
  showAllCategories,
  setShowAllCategories,
}) => {
  // On mount: parse URL and set filters if empty (to initialize from URL)
useEffect(() => {
  const path = window.location.pathname;
  if (!path.startsWith("/filter")) return;

  const segments = path.replace(/^\/filter\/?/, "").split("/").filter(Boolean); // remove empty

  const filterFromPath = {};
  for (let i = 0; i < segments.length; i += 2) {
    const key = segments[i];
    const value = segments[i + 1] || "";
    if (key && value) {
      filterFromPath[key] = decodeURIComponent(value.trim());
    }
  }

  // Handle date range
  if (filterFromPath.dateRange && filterFromPath.dateRange.includes("_")) {
    const [start_date, end_date] = filterFromPath.dateRange.split("_");
    filterFromPath.start_date = start_date;
    filterFromPath.end_date = end_date;
    delete filterFromPath.dateRange;
  }

  const hasNoFilters = Object.values(filters).every((v) => !v);
  if (hasNoFilters && Object.keys(filterFromPath).length > 0) {
    const updatedFilters = { ...filters, ...filterFromPath };
    setFilters(updatedFilters);
    handleSearch(updatedFilters);
  }
}, []);





  // Initialize datepickers and update state on date change
  useEffect(() => {
    $("#start_date")
      .datepicker({
        dateFormat: "yy-mm-dd",
        onSelect: (dateText) => {
          setFilters((prev) => {
            const updated = { ...prev, start_date: dateText };
            updateURL(updated);
            handleSearch(updated);
            return updated;
          });
        },
      })
      .datepicker("setDate", filters.start_date || null);

    $("#end_date")
      .datepicker({
        dateFormat: "yy-mm-dd",
        onSelect: (dateText) => {
          setFilters((prev) => {
            const updated = { ...prev, end_date: dateText };
            updateURL(updated);
            handleSearch(updated);
            return updated;
          });
        },
      })
      .datepicker("setDate", filters.end_date || null);
  }, [filters.start_date, filters.end_date]);




const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);


// ✅ Hardcoded top country names
const topCountryNames = [
  "United States", "UK", "Germany", "UAE", "Canada", "Australia",
  "India", "China", "France", "Netherlands", "Singapore", "Japan"
];

// ✅ Derive top and remaining from fetched countries
const topCountries = countries.filter(c => topCountryNames.includes(c.name));
const remainingCountries = countries.filter(c => !topCountryNames.includes(c.name));

// Optional: You can do the same for states if needed
const topStates = states.slice(0, 10);
const remainingStates = states.slice(10);

  // const topStates = states.slice(0, 10);
  // const remainingStates = states.slice(10);


const API_KEY = "YUwzclYySVhOZVpsZERWMXo5ZWYycERDWGRJbUdNMHl5VGZVak5ZTA==";

// Fetch countries on mount
 // Fetch countries on mount
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get("https://api.countrystatecity.in/v1/countries", {
          headers: { "X-CSCAPI-KEY": API_KEY },
        });
        setCountries(response.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  // Fetch states when country is selected
  useEffect(() => {
    const selectedCountry = countries.find((c) => c.name === filters.country);
    if (!selectedCountry) {
      setStates([]);
      return;
    }

    const fetchStates = async () => {
      try {
        const response = await axios.get(
          `https://api.countrystatecity.in/v1/countries/${selectedCountry.iso2}/states`,
          {
            headers: { "X-CSCAPI-KEY": API_KEY },
          }
        );
        setStates(response.data);
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };

    fetchStates();
  }, [filters.country, countries]);



















 const pickerRef = useRef(null);
  const [show, setShow] = useState(false);
  const fpInstance = useRef(null); // To store flatpickr instance

  // Helper functions and predefinedRanges as you have
  const daysAgo = (n) => {
    const d = new Date();
    d.setDate(d.getDate() - n);
    return d;
  };


  const daysFromNow = (n) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return d;
};

const predefinedRanges = [
  {
    label: "Today",
    getRange: () => {
      const today = new Date();
      return [today, today];
    },
  },
  {
    label: "Tomorrow",
    getRange: () => {
      const tomorrow = daysFromNow(1);
      return [tomorrow, tomorrow];
    },
  },
  {
    label: "Next 7 days",
    getRange: () => [new Date(), daysFromNow(6)],
  },
  {
    label: "Next 30 days",
    getRange: () => [new Date(), daysFromNow(29)],
  },
  {
    label: "Next 90 days",
    getRange: () => [new Date(), daysFromNow(89)],
  },
  {
    label: "This year",
    getRange: () => {
      const now = new Date();
      const start = new Date(now.getFullYear(), 0, 1);
      const end = new Date(now.getFullYear(), 11, 31);
      return [start, end];
    },
  },
  {
    label: "All time",
    getRange: () => [new Date(2000, 0, 1), new Date(2100, 11, 31)],
  },
];
  // Apply range helper to update filters and flatpickr calendar
  const applyRange = (start, end) => {
    const s = start.toISOString().slice(0, 10);
    const e = end.toISOString().slice(0, 10);
    const updatedFilters = { ...filters, start_date: s, end_date: e };

    setFilters(updatedFilters);
    updateURL(updatedFilters);
    handleSearch(updatedFilters);

    // Update flatpickr selected dates
    if (fpInstance.current) {
      fpInstance.current.setDate([start, end], false); // false = don't trigger onChange again
    }
  };

  // Initialize flatpickr only when 'show' becomes true, and cleanup on unmount or hide
  useEffect(() => {
    if (show && pickerRef.current && !fpInstance.current) {
      fpInstance.current = flatpickr(pickerRef.current, {
  mode: "range",
  dateFormat: "Y-m-d",
  defaultDate:
    filters.start_date && filters.end_date
      ? [filters.start_date, filters.end_date]
      : null,
  inline: true,  // <-- add this line!
  onChange: (selectedDates) => {
    if (selectedDates.length === 2) {
      applyRange(selectedDates[0], selectedDates[1]);
    }
  },
});

    }

    if (!show && fpInstance.current) {
      // Optionally clear flatpickr instance to avoid memory leaks
      fpInstance.current.destroy();
      fpInstance.current = null;
    }

    // Cleanup on unmount
    return () => {
      if (fpInstance.current) {
        fpInstance.current.destroy();
        fpInstance.current = null;
      }
    };
  }, [show]);

const slugify = (text) =>
  text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-") // Replace spaces and non-alphanumeric
    .replace(/^-+|-+$/g, ""); // Remove leading/trailing hyphens





const updateURL = (filters) => {
  const segments = [];

  if (filters.country) segments.push("country", encodeURIComponent(filters.country));
  if (filters.state) segments.push("state", encodeURIComponent(filters.state));
  if (filters.city) segments.push("city", encodeURIComponent(filters.city));
  if (filters.industry) segments.push("industry", encodeURIComponent(filters.industry));
  if (filters.format) segments.push("format", encodeURIComponent(filters.format));
  if (filters.start_date && filters.end_date) {
    segments.push("dateRange", `${filters.start_date}_${filters.end_date}`);
  }

  const url = `/filter/${segments.join("/")}`;

  if (window.location.pathname !== url) {
    window.location.href = url;
  }
};


const handleSingleCheckboxChange = (field, value) => {
  setFilters((prev) => {
    const newValue = prev[field] === value ? "" : value;

    const updated = {
      ...prev,
      [field]: newValue,
    };

    // ✅ Remove keys with falsy (empty) values
    const cleanedFilters = Object.fromEntries(
      Object.entries(updated).filter(([_, v]) => !!v)
    );

    updateURL(cleanedFilters);
    return updated;
  });
};


  // Show only 10 industries if showAllCategories is false
  const showCategoryList = showAllCategories
    ? industriesList
    : industriesList.slice(0, 10);

  return (
    <>
      <h3 className="ft-tags">Filter</h3>

      {/* Date Filter */}
      <h2 className="ft-event1">Calander</h2>
      <hr className="my-1" />


      <div className="position-relative" style={{ maxWidth: 300 }}>
      <input
        type="text"
        readOnly
        className="inputsearch w-100" style={{cursor: 'pointer'}}
        onClick={() => setShow(!show)}
        value={
          filters.start_date && filters.end_date
            ? `${filters.start_date} - ${filters.end_date}`
            : ""
        }
        placeholder="Select date range"
      />

      {show && (
        <div className="custom-datepicker-popup shadow p-1" style={{ zIndex: 9999, background: "white", position: "absolute", top: "100%", left: 0 }}>
          <div className="d-flex">
            {/* Flatpickr calendar inside here */}
            <div ref={pickerRef} className="me-3"
            style={{ minHeight: 250 }} 
             />

            {/* Predefined Ranges */}
            <div className="preset-list" style={{ minWidth: 120 }}>
              {predefinedRanges.map((item, idx) => (
                <div
                  key={idx}
                  className="preset-option"
                  style={{ cursor: "pointer", padding: "4px 8px", borderRadius: 4, marginBottom: 4, background: "#eee", fontSize: '12px' }}
                  onClick={() => {
                    applyRange(...item.getRange());
                    setShow(false);
                  }}
                >
                  {item.label}
                </div>
              ))}
            </div>
          </div>
          <button
            className="btn btn-primary btn-sm mt-2 float-end"
            onClick={() => setShow(false)}
          >
            Apply
          </button>
        </div>
      )}
    </div>














     {/* Country Filter */}
      <h2 className="ft-event1 mt-2">Country</h2>
      <hr className="my-1" />
      {topCountries.map((country, i) => (
        <div className="form-check mb-0" key={`country-${country.iso2}`}>
          <input
            className="form-check-input"
            type="checkbox"
            name="country"
            id={`country-${i}`}
            value={country.name}
            onChange={() => handleSingleCheckboxChange("country", country.name)}
            checked={filters.country === country.name}
          />
          <label className="form-check-label industries2" htmlFor={`country-${i}`}>
            {country.name}
          </label>
        </div>
      ))}

      {remainingCountries.length > 0 && (
        <button className="btn btn-sm btn-link mt-2" data-bs-toggle="modal" data-bs-target="#countryModal">
          Show More Countries
        </button>
      )}

      {/* State Filter */}
      {states.length > 0 && (
        <>
          <h2 className="ft-event1 mt-3">State</h2>
          <hr className="my-1" />
          {topStates.map((state, i) => (
            <div className="form-check mb-0" key={`state-${state.iso2}`}>
              <input
                className="form-check-input"
                type="checkbox"
                name="state"
                id={`state-${i}`}
                value={state.name}
                onChange={() => handleSingleCheckboxChange("state", state.name)}
                checked={filters.state === state.name}
              />
              <label className="form-check-label industries2" htmlFor={`state-${i}`}>
                {state.name}
              </label>
            </div>
          ))}

          {remainingStates.length > 0 && (
            <button className="btn btn-sm btn-link mt-2" data-bs-toggle="modal" data-bs-target="#stateModal">
              Show More States
            </button>
          )}
        </>
      )}

      {/* Country Modal */}
      <div className="modal fade" id="countryModal" tabIndex="-1" aria-labelledby="countryModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Select Countries</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              {remainingCountries.map((country, i) => (
                <div className="form-check mb-0" key={`country-modal-${country.iso2}`}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="country"
                    id={`country-modal-${i}`}
                    value={country.name}
                    onChange={() => handleSingleCheckboxChange("country", country.name)}
                    checked={filters.country === country.name}
                  />
                  <label className="form-check-label industries2" htmlFor={`country-modal-${i}`}>
                    {country.name}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* State Modal */}
      <div className="modal fade" id="stateModal" tabIndex="-1" aria-labelledby="stateModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Select States</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              {remainingStates.map((state, i) => (
                <div className="form-check mb-0" key={`state-modal-${state.iso2}`}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="state"
                    id={`state-modal-${i}`}
                    value={state.name}
                    onChange={() => handleSingleCheckboxChange("state", state.name)}
                    checked={filters.state === state.name}
                  />
                  <label className="form-check-label industries2" htmlFor={`state-modal-${i}`}>
                    {state.name}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>




















      {/* Industry filter */}
      <h2 className="ft-event1 mt-2">Industry</h2>
      <hr className="my-1" />
      {showCategoryList.map((industry, index) => (
        <div className="form-check  mb-0" key={`industry-${index}`}>
          <input
            className="form-check-input"
            type="checkbox"
            name="industry"
            id={`industry-${index}`}
            value={industry.industry_name}
            onChange={() =>
              handleSingleCheckboxChange("industry", industry.industry_name)
            }
            checked={filters.industry === industry.industry_name}
          />
          <label
            className="form-check-label d-flex justify-content-between"
            htmlFor={`industry-${index}`}
          >
            <span className="industries2">{industry.industry_name}</span>
            <span className="industries3">({industry.industry_count})</span>
          </label>
        </div>
      ))}

      {industriesList.length > 10 && (
        <button
          className="btn btn-link p-0"
          onClick={() => setShowAllCategories(true)}
          data-bs-toggle="modal"
          data-bs-target="#categoryModal"
        >
          Show All Industry
        </button>
      )}

      {/* Modal for All Industries */}
      <div
        className="modal fade"
        id="categoryModal"
        tabIndex="-1"
        aria-labelledby="categoryModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="categoryModalLabel">
                All Industry
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setShowAllCategories(false)}
              ></button>
            </div>
            <div className="modal-body">
              {industriesList.map((industry, index) => (
                <div className="form-check" key={`modal-industry-${index}`}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="modal-industry"
                    id={`modal-industry-${index}`}
                    value={industry.industry_name}
                    onChange={() =>
                      handleSingleCheckboxChange("industry", industry.industry_name)
                    }
                    checked={filters.industry === industry.industry_name}
                  />
                  <label
                    className="form-check-label d-flex justify-content-between"
                    htmlFor={`modal-industry-${index}`}
                  >
                    <span className="industries2">{industry.industry_name}</span>
                    <span className="industries3">({industry.industry_count})</span>
                  </label>
                </div>
              ))}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => setShowAllCategories(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Format filter */}
      <h2 className="ft-event1 mt-2">Format</h2>
      <hr className="my-1" />
      {["Exhibition", "Conference", "Workshop", "Concert", "Sport"].map(
        (format, i) => (
          <div className="form-check  mb-0" key={`format-${i}`}>
            <input
              className="form-check-input"
              type="checkbox"
              name="format"
              id={`format-${i}`}
              value={format}
              onChange={() => handleSingleCheckboxChange("format", format)}
              checked={filters.format === format}
            />
            <label
              className="form-check-label d-flex justify-content-between"
              htmlFor={`format-${i}`}
            >
              <span className="industries2">{format}</span>
            </label>
          </div>
        )
      )}

      
    </>
  );
};

export default Sidefilter;
